export default "__VITE_ASSET__22b3074f__"